import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
  filters: {
    search_text: "",
    myobStatus: "",
    customerId: "",
    startDate: moment().startOf("day").format("YYYY-MM-DD"),
    endDate: moment().endOf("day").format("YYYY-MM-DD"),
    searchRange: "1month",
  },
  sorting: {
    sortField: "order_unique_id",
    sortDirection: "-1",
  },
  // Multi-field column filter (chips built from the ⋮ column menu) — kept in redux so it
  // survives navigating into an order and back, not just component remounts.
  columnFilterModel: { items: [] },
  activeTab: 0,
};

const masterOrderSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    setSorting(state, action) {
      state.sorting = action.payload;
    },
    setColumnFilterModel(state, action) {
      state.columnFilterModel = action.payload;
    },
    setActiveTab(state, action) {
      state.activeTab = action.payload;
    },
    resetFiltersAndSorting(state) {
      state.filters = initialState.filters;
      state.sorting = initialState.sorting;
      state.columnFilterModel = initialState.columnFilterModel;
    },
  },
});

export const { setFilters, setSorting, setColumnFilterModel, setActiveTab, resetFiltersAndSorting } = masterOrderSlice.actions;
export default masterOrderSlice.reducer;
